import { render, staticRenderFns } from "./mall.vue?vue&type=template&id=1ea6a417"
import script from "./mall.vue?vue&type=script&lang=js"
export * from "./mall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ea6a417')) {
      api.createRecord('1ea6a417', component.options)
    } else {
      api.reload('1ea6a417', component.options)
    }
    module.hot.accept("./mall.vue?vue&type=template&id=1ea6a417", function () {
      api.rerender('1ea6a417', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/config/mall.vue"
export default component.exports